var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.multi)?_c('app-select-bank-kind',{attrs:{"value":_vm.singleValue,"label":_vm.label,"fancy":""},on:{"input":function($event){return _vm.setSingleValue($event)}}}):_c('app-multi-select-bank-kind',{attrs:{"value":_vm.value,"label":_vm.label,"fancy":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }